import { render, staticRenderFns } from "./OrganProjectClassManage.vue?vue&type=template&id=78fcf8eb&scoped=true"
import script from "./OrganProjectClassManage.vue?vue&type=script&lang=js"
export * from "./OrganProjectClassManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fcf8eb",
  null
  
)

export default component.exports